import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Density } from "@/theme";

interface DensityState {
  density: Density;
  toggle: () => void;
  setDensity: (d: Density) => void;
}

/** Comfortable (default) vs compact row/field density — a familiar enterprise control. Persisted. */
export const useDensity = create<DensityState>()(
  persist(
    (set, get) => ({
      density: "comfortable",
      toggle: () => set({ density: get().density === "compact" ? "comfortable" : "compact" }),
      setDensity: (density) => set({ density }),
    }),
    { name: "invmgmt-density" }
  )
);
